import { createFileRoute } from "@tanstack/react-router";
import { PortalShell } from "@/components/portal/PortalShell";
import { RoleDashboard } from "@/components/portal/RoleDashboard";

const NAV = [
  { to: "/app/expert", label: "Dashboard" },
  { to: "/app/approvals", label: "Freigaben" },
  { to: "/app/crm/projects", label: "Projekte" },
];

export const Route = createFileRoute("/_authenticated/app/expert")({
  ssr: false,
  head: () => ({ meta: [{ title: "Expertenportal" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <PortalShell nav={NAV}>
      <RoleDashboard title="Expertenportal" scope="expert" />
    </PortalShell>
  ),
});
